import * as React from 'react';
import Button from '@mui/material/Button';
import { useMutation } from '../hooks/useMutation';
import { toastr } from 'app/common/toastr';

const RESEND_EMAIL_VERIFICATION = `mutation resendEmailVerification($email: String!) { 
  resendEmailVerification(email: $email)
}`;

const ResendEmailVerification = ({ props }) => {
  const { mutate } = useMutation(RESEND_EMAIL_VERIFICATION);

  const onClickHandler = async () => {
    const { data } = await mutate({
      email: props.user.get('email')
    });

    if (data.resendEmailVerification === true) {
      toastr.success(
        props.i18n('Resend email verification'),
        props.i18n('An email verification has been send')
      );
    } else {
      toastr.error(
        props.i18n('Resend email verification'),
        props.i18n(
          'Oops! Something went wrong. Please try again or contact customer support'
        )
      );
    }
  };

  return (
    <Button
      color="primary"
      variant="text"
      style={{ margin: '8px 12px 12px 0' }}
      onClick={() => onClickHandler()}
    >
      {props.i18n('Resend email verification')}
    </Button>
  );
};

export default ResendEmailVerification;